// app.service.js
import angular from "angular";
import config from 'app/config';

class appService {
  constructor($location, $window, $rootScope, $httpParamSerializer) {
    this.config = config;
    this.$location = $location;
    this.$window = $window;
    this.$rootScope = $rootScope;
    this.$httpParamSerializer = $httpParamSerializer;
  }

  // Check key in object
  hasProperty(object, key) {
    return Object.prototype.hasOwnProperty.call(object, key);
  }

  // retutn key value from object
  getProperty(object, key) {
    return this.hasProperty(object, key) ? object[key] : "";
  }

  // Query Params : read alll the query param and retun as object
  getQueryParamObject() {
    const urlSearchParams = new URLSearchParams(this.$window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    return params;
  }

  // Query Params : read alll the query param and retun as string
  getQueryParam() {
    var param = this.$window.location.search.substring(1);
    return param;
  }

  //set url to redirct with query param attached to it
  cta(url) {
    var noaction = ['NA','hsevent','optin',undefined];
    if(noaction.indexOf(url) < 0) {
      var qparams = this.getQueryParamObject();
      qparams = this.$httpParamSerializer(angular.extend(qparams, this.queryStringToJSON(url)));
      if(qparams != '') {
        url = url.split('?')[0] + '?' + qparams;
      }
    }
    return url;
  }

  // Query Params : read alll the query param and retun as object
  appendParam(key, value) {
    let params = new URLSearchParams(this.getQueryParam());
    params.append(key, value);
    return params.toString();
  }

  queryStringToJSON(str) {
    var pairs = [];
    var result = {};
    if(str.indexOf('?') > -1) {
     pairs = str.slice(str.indexOf('?') + 1).split('&');
    }
    if(pairs.length > 0) {
      pairs.forEach((pair) => {
        pair = pair.split('=');
        var name = pair[0]
        var value = pair[1]
        if( name.length )
            if (result[name] !== undefined) {
                if (!result[name].push) {
                    result[name] = [result[name]];
                }
            result[name].push(value || '');
            } else {
                result[name] = value || '';
            }
    });
    }
    return result;
  }

  // Query Params : read alll the query param and retun as string
  getUserQueryParam() {
    var qparams = this.getQueryParamObject();
    var userinfo = {};
    angular.forEach({'email':'','firstname':'','fname':'','lastname':'','lname':''}, (value, key) => {
      if(this.hasProperty(qparams, key) && qparams[key] != ''){
        this[key] = qparams[key];
      }
    }, userinfo);
    return this.$httpParamSerializer(userinfo);
  }

  // Browser : detect the client browser and retutn the browser agent
  browser() {
    var userAgent = this.$window.navigator.userAgent;
    var browsers = {chrome: /chrome/i, safari: /safari/i, firefox: /firefox/i, ie: /internet explorer/i};
    for(var key in browsers) {
      if (browsers[key].test(userAgent)) {
        return key;
      }
    }
    return 'unknown';
  }

  // Mobile : detect the mobile device and return true if mobile
  // isMobile() {
  //   var check = false;
  //   (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  //   return check;
  // }

  // get GA client to bind in the cross domain redirects
  getClientID() {
    let ga;
    try {
      //ga('create', 'UA-74784456-1', 'auto');
      var tracker = ga.getAll()[0];
      return tracker.get('clientId');
    } catch(e) {
      console.log("Error fetching clientId");
      return "n/a";
    }
  }

  // ecommerce tracking in GTM to analyze purchase activity
  ecomTracking(cart) {
    window.dataLayer = window.dataLayer || [];
    var transactionProducts = [];
    var cartItems = cart.items;
    for (var i = 0; i < cartItems.length; i++) {
      transactionProducts.push({
        'sku': '' + cartItems[i].itemId + '',
        'name': '' + cartItems[i].itemId + '',
        'price': parseInt(cartItems[i].totalCost, 10),
        'quantity': parseInt(cartItems[i].quantity, 10)
      });
    }
    window.dataLayer.push({
      'transactionId': cart.cartId,
      'transactionAffiliation': cart.affiliateId,
      'transactionTotal': cart.total,
      'transactionTax': cart.tax,
      'transactionProducts': transactionProducts,
      'event': 'Report Ecommerce'
    });

  }

  // set cookie in browser
  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  /**
  * Get the value of a cookie
  * @param  {String} name  The name of the cookie
  * @return {String}       The cookie value
  */
  getCookie(name) {
    let value = `; ${document.cookie}`;
    let parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  // getData() {
  //   const REPOS = "users/var-bin/repos";
  //   const URL = `${this.API_URL}/${REPOS}`;
  //
  //   return this.$http.get(URL)
  //     .then((response) => response.data);
  // }
}

appService.$inject = ["$location", "$window" ,"$rootScope", "$httpParamSerializer"];

// export default {
//   name: 'appService',
//   factory: new appService();
// }

export { appService }
